// extracted by mini-css-extract-plugin
export default {"settingsTitle":"Place_settingsTitle__vT-AV"};